// Useful for mocking in shallow tests.
// Component can read this getter and tests can
// easily mock it
export const getWindow = () => window
